<template>
  <div id="specificity-override" class="launcher">
    <div>
      <h1>Welcome {{ name }}</h1>
    </div>
    <div class="grid">
      <div class="row" @click="gotTo('/hh')" v-if="getIcoaButton() === 'hh'">
        <span>HH/PPE Reporting &#8674;</span>
        <span>Hand Hygiene and PPE reports</span>
      </div>
      <div class="row" @click="gotTo('/dashboard')" v-if="getIcoaButton() === 'ipac'">
        <span>IPAC Management &#8674;</span>
        <span>Infection Surveillance, Outbreak Management, and Hand Hygiene and PPE reports</span>
      </div>
      <div class="row" @click="gotTo('hand hygiene')" v-if="hasHandHygiene()">
        <span>HH/PPE Administrator &#8674;</span>
        <span>Hand Hygiene and PPE observations</span>
      </div>
      <div class="row" @click="gotTo('myaudits')" v-if="hasMyAudits()">
        <span>MyAudits &#8674;</span>
        <span>Customized compliance auditing platform</span>
      </div>
      <div class="row" @click="gotTo('/compliance')" v-if="hasComplianceAI()">
        <span>CareCompliance AI &#8674;</span>
        <span>AI generated action plans and inspection reports management</span>
      </div>
      <div class="row" @click="gotTo('/uam')" v-if="hasUAM()">
        <span>Administration &#8674;</span>
        <span>User account management</span>
      </div>
    </div>
    <div>
      <h2>Need Support?</h2>
      Email us at <a :href="getSupportEmail()">support@healthconnex.ai </a>
    </div>
  </div>
</template>

<script>
import auth from "../../auth";
export default {
  name: "Page",
  data() {
    return {
      name: ""
    };
  },
  methods: {
    getSupportEmail() {
      const { org } = auth.parseJwt(auth.getToken());
      return `mailto:support@healthconnex.ai?subject=IPAC support request [${org}]:`
    },
    hasRole(role) {
      return auth.userInfo().roles.includes(role);
    },
    gotTo(path) {
      // this.$router.push(path);
      if (path === "hand hygiene") {
        window.open(`${window.CONFIG.ipac_web_host}${window.CONFIG.ipac_web_port}`, "_blank");
      } else if (path === "myaudits") {
        window.open(`${window.CONFIG.my_audits_host}${window.CONFIG.my_audits_port}`, "_blank");
      } else {
        window.open(path, "_blank");
      }
    },
    hasIPAC() {
      return this.hasRole("ROLE_NURSE");
    },
    hasMyAudits() {
      return this.hasRole("MA_AUDIT_READ");
    },
    hasHandHygiene() {
      return this.hasRole("ROLE_HH_OBSERVER") && (this.$configStore.hhModuleEnabled() || this.$configStore.hhModuleEnabled());
    },
    hasUAM() {
      return this.hasRole("UAM_CREATE");
    },
    hasComplianceAI() {
      return this.hasRole("CC_READ") && this.$configStore.complianceAIEnabled();
    },
    hhOnly() {
      return this.$configStore.hhOnly();
    },
    getIcoaButton() {
      if (this.$configStore.hhOnly() && this.$configStore.hhModuleEnabled()) {
        return "hh";
      } else if (this.hasRole("ROLE_NURSE")) {
        return "ipac";
      } else if (this.hasRole("ROLE_HH_WEB_OBSERVER") && this.$configStore.hhModuleEnabled()) {
        return "hh";
      }
      return null;
    }
  },
  mounted() {
    const { name } = auth.parseJwt(auth.getToken());
    this.name = name;
  }
};
</script>

<style scoped>
.launcher {
  --blue-normal: #0161b5;
  --blue-hover: #3fa1f6;
  display: flex;
  flex-direction: column;
  gap: 1.5dvw;
  max-width: 800px;
  margin: 1dvw auto 0;
  width: 80dvw;
}
.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 1%;
}
.row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  backdrop-filter: blur(5px);
  flex: 0 0 49.5%;
  transition: background-color 200ms ease-out;
  box-shadow: 0px 5px 10px -5px rgb(0 0 0 / 0.25);
}
.row:hover {
  background-color: rgb(255 255 255 / 1);
}
#specificity-override h1 {
  font-size: 1.5rem;
  margin: 0 0 0 0;
}
#specificity-override h2 {
  font-size: 1.2rem;
  margin: 0 0 0.5rem 0;
}
#specificity-override .row :first-child {
  margin: 0 auto 0 0;
  font-size: 1.25rem;
  text-decoration: none;
  color: var(--blue-normal);
  text-shadow: 0 1px 2px rgb(0 0 0 / 0.25);
}
#specificity-override .row:hover :first-child {
  color: var(--blue-hover);
}
</style>
<style>
.top-menu {
  border-bottom: 1px solid rgb(65 64 72);
  background: rgb(245 246 238 / 0.65);
  backdrop-filter: blur(20px);
}
.right-content:has(> .launcher) {
  left: 0px;
  background: linear-gradient(0deg, rgba(42, 123, 155, 0.5) 0%, rgba(87, 199, 133, 0.5) 26%, rgba(249, 249, 244, 0.9) 100%);
  backdrop-filter: invert(1);
}
.right-content:has(> .launcher) + .copyright {
  display: none;
}
body:has(.launcher) {
  background: url(../../assets/launcher_bg.png) no-repeat top left;
  background-size: cover;
}

@media (width <= 768px) {
  .grid {
    flex-direction: column;
  }
}
</style>
